// src/TCContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import config from '../config';

const TCContext = createContext();

export function TCProvider({ children }) {
  const [tcData, setTCData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${config.apiBaseUrl}/tc/getGeneratedTC.php`);
      const data = await response.json();
      setTCData(data);
    } catch (error) {
      console.error('Error fetching TC data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchTCs = () => {
    fetchData();
  };

  return (
    <TCContext.Provider value={{ tcData, loading, fetchTCs }}>
      {children}
    </TCContext.Provider>
  );
}

export function useTCData() {
  const context = useContext(TCContext);
  if (context === undefined) {
    throw new Error('useTCData must be used within a TCProvider');
  }
  return context;
}
